import React, { useEffect, Fragment } from 'react';

//redux
import { IRootState } from 'redux/reducers';
import { useSelector, useDispatch } from 'react-redux'
import WorkspacesAction from '../../redux/actions/workspaces/WorkspacesAction'

//interfaces
import { Workspace } from '../../interfaces/workspaces';

//components
import { WorkspaceItem } from '../elements/workspaces/WorkspaceItem'
import ModalHeader from './ModalHeader'
import SimpleBar from 'simplebar-react';

//styling
import '../../css/dist/simplebar.min.css';



type Props = {
    onClose: () => void,
    showWelcome: boolean
}

const YourWorkspacesModal = (props:Props) => {

    const dispatch = useDispatch()
   
    const yourWorkspaces:Workspace[] = useSelector((state: IRootState)  => state.workspaces.allWorkspaces)
    const profileImage = useSelector((state: IRootState)  => state.profile.profileImage)

    useEffect(() => {dispatch(WorkspacesAction.requestAllWorkspaces())}, [])

    useEffect(() => {
        // Check if there is only 1 workspace, if so forward
        if(yourWorkspaces.length === 1){
            window.location.href = `${yourWorkspaces[0].url}?showmodel=${props.showWelcome}`
            sessionStorage.setItem("showmodel", props.showWelcome.toString());
        }

    }, [dispatch, yourWorkspaces]);


    return (
        <Fragment>
    
            {yourWorkspaces.length > 1 &&
                <Fragment>
                    <ModalHeader title='Choose your workspace' text='What workspace would you like to go to?' imageURL={profileImage} />

                    <SimpleBar style={{ maxHeight: 360 }}  forceVisible={true} autoHide={false}  >
                        <div className="workspace-selector-modal">
                            <ul className="workspace-list">

                                {yourWorkspaces.map((x:Workspace) => {
                                    return(
                                        <WorkspaceItem item={x} count={false} key={x.guid} showmodel={props.showWelcome} titleLength={15} />
                                    )  
                                })}

                            </ul>
                        </div>
                    </SimpleBar>
                </Fragment>
            }

            {!yourWorkspaces.length &&
                <div className="no-workspaces-modal">
                    <h2>Sorry, you dont have any workspaces setup yet - please contact your admin</h2>            
                    <button onClick={() => props.onClose()}>Close</button>
                </div>
            }

        </Fragment>
    );
}

export default YourWorkspacesModal;